import { baseFetch } from '../../baseFetch';
import { PartnersListSchema } from './partners.schema';

export const getPartners = () =>
  baseFetch('internal-v2', '/partners', PartnersListSchema);
